import $ from "jquery";


/**
 * Focus Traps are used in modals and other blocking content that needs focus to remain inside.
 */

const TrapFocus = (el) => {
    const $el = $(el);

    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const firstFocusableElement = $el.find(focusableElements)[0];
    const focusableContent = $el.find(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1];


    document.addEventListener('keydown', function(e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus();
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus();
                e.preventDefault();
            }
        }
    });

    firstFocusableElement.focus();
}


export default TrapFocus;



